// eslint-disable-next-line 
import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import LaunchIcon from '@mui/icons-material/Launch';
import axios from 'axios';
import { ContextData } from '../../../../../../../context/Context';
import baseUrl from '../../../../../../../BaseURL';
import { toast } from 'react-toastify';
import Loader from '../../../../../../../routes/Loader';

export default function Instruction(props) {


  const [open, setOpen] = React.useState(false);
  const [scroll, setScroll] = React.useState('paper');
  const { AdministratorTokens } = React.useContext(ContextData);
  const [ScholarshipAppliedList, setScholarshipAppliedList] = React.useState(null);
  const { user_token, scholarship_applied, scholarship_type, schl_token, setOpenLoader } = props;
  const [ReloadApp, setReloadApp] = React.useState(true);
  const [isButtonDisabled, setIsButtonDisabled] = React.useState(false);

  const handleClickOpen = (scrollType) => () => {
    setOpen(true);
    setScroll(scrollType);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleFormSubmit = async () => {
    if (!user_token || !scholarship_applied || !scholarship_type || !schl_token) {
      toast.warn("All fields are required!");
      return;
    }

    setOpenLoader(true);
    setIsButtonDisabled(true);


    try {
      const response = await axios.post(`${baseUrl}/auth/apply_scholarship`, {
        user_token,
        scholarship_applied,
        scholarship_type,
        schl_token,
      });
      toast.success(response.data.message);
      setReloadApp(!ReloadApp);
      setOpen(false);
      setOpenLoader(false);
      setIsButtonDisabled(true);

    } catch (error) {
      toast.error("Error submitting application. Please try again.");
      console.error("Submission error:", error);
      setReloadApp(!ReloadApp);
      setOpenLoader(false);
      setIsButtonDisabled(false);
    }
  };

  const descriptionElementRef = React.useRef(null);

  React.useEffect(() => {
    if (open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [open]);

  React.useEffect(() => {
    async function FetchData() {
      try {
        const response = await axios.get(`${baseUrl}/auth/get_cholarship_applied_list/${user_token}/${schl_token}`, {
          withCredentials: true,
          headers: {
            'Accept': 'application/json',
            'authorization': `Bearer ${AdministratorTokens !== null && AdministratorTokens}`
          }
        });

        setScholarshipAppliedList(response.data[0]);
        setIsButtonDisabled(response.data[0].apply_status === "applied")
        
      } catch (err) {
        if (err) console.log(err.message);
      }
    }
    FetchData();
  }, [ReloadApp]);

  return (
    <React.Fragment>
     
      <Button
        disabled={isButtonDisabled}
        onClick={handleClickOpen('paper')}
        sx={{ whiteSpace: 'nowrap', textTransform: "capitalize", fontSize: '14px', backgroundColor: 'rgb(0, 24, 69)', color: "white", margin: '9px 4px', fontWeight: "800" }}
        size="medium"
        variant="contained"
      >
        <LaunchIcon sx={{ fontSize: "1.6em", marginRight: "2px" }} /> Apply
      </Button>

      <Dialog open={open} onClose={handleClose} scroll={scroll} aria-labelledby="scroll-dialog-title" aria-describedby="scroll-dialog-description">
        <DialogTitle id="scroll-dialog-title"><span className='text-cyan-900'>Read Before Apply</span></DialogTitle>
        <DialogContent dividers={scroll === 'paper'}>
          <DialogContentText id="scroll-dialog-description" ref={descriptionElementRef} tabIndex={-1}>
            <p style={{ whiteSpace: "pre-line" }}>{props.value}</p>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            disabled={isButtonDisabled}
            onClick={handleFormSubmit}
            sx={{ whiteSpace: 'nowrap', textTransform: "capitalize", fontSize: '14px', backgroundColor: 'rgb(0, 24, 69)', color: "white", margin: '9px 4px', fontWeight: "800" }}
            size="medium"
            variant="contained"
          >
            <LaunchIcon sx={{ fontSize: "1.6em", marginRight: "2px" }} /> Agree and Apply
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
